// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prt-button {
  background-color: #005a9c;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin: 1rem 16px 0; /* top: 1rem, left/right: 6px, bottom: 0 */
}

.prt-button:hover {
  background-color: #003f73;
}

@media print {
  .prt-button {
    display: none; /* hide button when printing */
  }
}

.nav-wrapper {
  display: flex;
  justify-content: center;
  gap: 12px; /* adds ⅛ inch spacing between buttons */
  margin-top: 1rem;
  margin-bottom: -18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PrtButton.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,mBAAmB,EAAE,0CAA0C;AACjE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa,EAAE,8BAA8B;EAC/C;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAE,wCAAwC;EACnD,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".prt-button {\n  background-color: #005a9c;\n  color: white;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin: 1rem 16px 0; /* top: 1rem, left/right: 6px, bottom: 0 */\n}\n\n.prt-button:hover {\n  background-color: #003f73;\n}\n\n@media print {\n  .prt-button {\n    display: none; /* hide button when printing */\n  }\n}\n\n.nav-wrapper {\n  display: flex;\n  justify-content: center;\n  gap: 12px; /* adds ⅛ inch spacing between buttons */\n  margin-top: 1rem;\n  margin-bottom: -18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
